export default __webpack_public_path__ + "static/media/trustero_logo_black.954c4b36.svg";